import { render, staticRenderFns } from "./mangopay-sca.vue?vue&type=template&id=6a194a2c"
import script from "./mangopay-sca.vue?vue&type=script&lang=js"
export * from "./mangopay-sca.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports